module.exports = __webpack_public_path__ + "img/journalism-theory.bdf54657.jpg";